import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { getTranslations, translationStatus } from "utils";
import { getPropertyId } from "utils/methods/index";

// Check localStorage for saved language preference
const propertyId = getPropertyId();
let initialLanguage = "en";

try {
  const savedLanguage = localStorage.getItem(`${propertyId}-hayley_language_preference`);
  
  if (savedLanguage && (savedLanguage === "en" || savedLanguage === "sp")) {
    initialLanguage = savedLanguage;
  }
} catch (error) {
  console.error("Failed to read language preference from localStorage:", error);
}

i18n.use(initReactI18next).init({
  resources: {}, // You'll populate this with translations later
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Fetch and load translations
const loadTranslations = (language) => {
  return getTranslations("hayley")
    .then((response) => response.json())
    .then((response) => {
      const translations = {};

      response.data.getTranslations.forEach((translation) => {
        translations.en = translations.en || {};
        translations.sp = translations.sp || {};

        translations.en[translation.key] = translation.english;
        translations.sp[translation.key] = translation.spanish;
      });

      // i18n.addResourceBundle(language, "translation", translations, true);
      i18n.addResourceBundle("en", "translation", translations.en, true);
      i18n.addResourceBundle("sp", "translation", translations.sp, true);

      translationStatus("success");
    })
    .catch((error) => {
      translationStatus("error");
      console.error("Failed to fetch translations:", error);
    });
};

// Load initial translations
loadTranslations("en"); // Load English translations initially

export default i18n;